/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/

// reactstrap components
import { Container, Row, Col, Nav, NavItem, NavLink } from 'reactstrap';
import APP_VERSION from '../../api/AppVersion';

const Footer = () => {
  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-center">
        <Col xl="6" className="text-center">
          <div className="copyright text-muted">
            Comprehend can make mistakes, check important info.
            <br />©{new Date().getFullYear()}{' '}
            <a
              className="font-weight-bold ml-1"
              href="https://www.comprehendpt.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              Comprehend PT
            </a>
          </div>
          <div style={{ fontSize: '0.7rem', color: '#adb5bd', marginTop: '4px' }}>
            v{APP_VERSION}
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
